<template>
    <inventories-find
        :inventory="$route.params.inventory"
        :include="['files(filters:with_erased=false)']"
        @success="onInventoriesFindSuccess"
    >
        <div
            slot-scope="{
                data: inventory,
                error: find_error,
                has_loaded,
                find
            }"
            :class="!has_loaded || find_error ? '' : 'rounded bg-white shadow'"
        >
            <template v-if="!has_loaded || find_error">
                <base-loading
                    :error="find_error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error"
                    :error="find_error"
                />
            </template>

            <inventories-update
                v-else
                :inventory="inventory.uuid"
                @success="onInventoriesUpdateSuccess"
            >
                <header class="flex items-center px-4 border-b h-18 sm:px-6">
                    <h1 class="text-lg font-normal truncate">
                        Edit {{ inventory.title }}
                    </h1>
                </header>

                <base-form
                    slot-scope="{
                        sid,
                        is_loading: is_saving,
                        error: update_error,
                        update
                    }"
                    @submit="update(form)"
                >
                    <div class="px-4 pt-6 border-b sm:px-6">
                        <validator-alert :sid="sid" />

                        <form-section>
                            <template slot="title">Basics</template>
                            <template slot="description">
                                We reccomend creating an inventory entry for each room/zone of the property
                            </template>

                            <grid-layout>
                                <grid-layout-item>
                                    <form-item
                                        :sid="sid"
                                        :is-required="true"
                                        name="title"
                                    >
                                        <template slot="label">Title</template>

                                        <input-text
                                            v-model="form.title"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            name="title"
                                            placeholder="e.g. Living room"
                                        />
                                    </form-item>
                                </grid-layout-item>

                                <grid-layout-item>
                                    <form-item
                                        :sid="sid"
                                        name="description"
                                    >
                                        <template slot="label">Description</template>

                                        <input-textarea
                                            v-model="form.description"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            name="description"
                                            class="min-h-3xs"
                                            placeholder="e.g. Walls: Plastered & painted magnolia. Free of marks stains, scuffs, picture hooks.

    Lights: Pendant ceiling light. All bulbs working.

    etc..."
                                        />

                                        <template slot="hint">Backup your description with photos/files.</template>
                                    </form-item>
                                </grid-layout-item>
                            </grid-layout>
                        </form-section>
                    </div>

                    <div class="px-4 pt-6 border-b sm:px-6">
                        <form-section>
                            <template slot="title">Files</template>
                            <template slot="description">
                                Upload your files/photos.
                            </template>

                            <grid-layout>
                                <grid-layout-item>
                                    <form-item
                                        :sid="sid"
                                        :is-required="true"
                                        name="uploads"
                                    >
                                        <template slot="label">Files</template>

                                        <input-uploads
                                            v-model="form.uploads"
                                            name="uploads"
                                            ref="uploads"
                                            :show-thumbs="true"
                                            :max-files="20"
                                            :sid="sid"
                                            :accepted-files="[
                                                'image/jpeg',
                                                'image/png',
                                                'application/pdf'
                                            ]"
                                            class="mr-3"
                                        />
                                    </form-item>
                                </grid-layout-item>
                            </grid-layout>
                        </form-section>
                    </div>

                    <div class="px-4 py-3 text-right bg-grey-bg sm:px-6">
                        <base-button
                            :is-loading="is_saving"
                            class="w-full btn-blue md:w-auto"
                        >
                            Update Inventory
                        </base-button>
                    </div>

                    <error-modal
                        v-if="update_error && $error.is(update_error, { exclude: [422] })"
                        :error="update_error"
                    />

                    <modal-success :is-open="show_updated_modal">
                        <template slot="heading">Inventory updated!</template>

                        <p>Your inventory has been updated.</p>

                        <div
                            slot="footer"
                            class="flex flex-col md:flex-row-reverse"
                        >
                            <router-link
                                :to="{
                                    name: $router.fix('dashboard.*.inventories.show'),
                                    params: {
                                        inventory: inventory.uuid
                                    }
                                }"
                                class="text-center btn btn-green"
                            >
                                Go to Inventory
                            </router-link>
                        </div>
                    </modal-success>
                </base-form>
            </inventories-update>
        </div>
    </inventories-find>
</template>

<script>
    import InventoriesFind from '../../../../components/inventories-find'
    import InventoriesUpdate from '../../../../components/inventories-update'

    export default {
        components: {
            InventoriesFind,
            InventoriesUpdate
        },
        data () {
            return {
                show_updated_modal: false,
                form: {
                    title: '',
                    description: '',
                    uploads: []
                }
            }
        },
        methods: {
            onInventoriesFindSuccess ({ data: inventory }) {
                this.form.title = inventory.title
                this.form.description = inventory.description
                this.form.uploads = inventory.files.data
            },
            onInventoriesUpdateSuccess () {
                setTimeout(() => {
                    // this.show_updated_modal = true
                }, 0)
            },
            reset () {
                this.$validator.reset(this.sid)

                this.$refs.uploads.reset()

                this.form.title = ''
                this.form.description = ''
                this.form.uploads = []
            }
        }
    }
</script>
